<script setup>
import { ArrowDownIcon } from '@heroicons/vue/24/solid'

defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['scroll-to-bottom'])
</script>

<template>
  <Transition
    enter-active-class="transition ease-out duration-200"
    enter-from-class="transform opacity-0 scale-95"
    enter-to-class="transform opacity-100 scale-100"
    leave-active-class="transition ease-in duration-150"
    leave-from-class="transform opacity-100 scale-100"
    leave-to-class="transform opacity-0 scale-95"
  >
    <button
      v-if="isVisible"
      type="button"
      class="absolute bottom-4 right-5 z-10 flex items-center justify-center rounded-full bg-primary-light px-2 py-4 transition focus:outline-none"
      @click="emit('scroll-to-bottom')"
    >
      <ArrowDownIcon class="h-4 w-4 text-white" />
    </button>
  </Transition>
</template>